import { apiClient } from '@/auth';

/**
 * Three OpenAI-backed chat-completion endpoints used by the recipe generator.
 * v1 calls these from `src/components/PatientAutopilot.tsx` to power the
 * "Suggest healthy recipes / a meal plan / healthy substitutions" flows; the
 * server is the privileged caller that holds the API key — clients only ever
 * post a prompt + temperature.
 *
 * Per swagger.yaml:12865-12926, all three endpoints share the same request and
 * response shape (OpenAIChatCompletionRequest / OpenAIChatCompletionResponse).
 */
export type OpenAIChatCompletionRequest = {
  prompt: string;
  /** Sampling temperature; v1 uses 0.5 for the substitution / meal-plan calls
   *  and the server default (1) for the generic recipe call. */
  temperature?: number;
};

export type OpenAIChatCompletionResponse = {
  text?: string;
  finish_reason: string;
  debug_info?: Record<string, unknown> | null;
  function_call?: Record<string, unknown> | null;
};

export type OpenAiVariant = 'recipes' | 'meal-plan' | 'food-substitutions';

const PATHS: Record<OpenAiVariant, string> = {
  'recipes': '/openai/chat-completion',
  'meal-plan': '/openai/chat-completion/meal-plan',
  'food-substitutions': '/openai/chat-completion/food-substitutions',
};

export const openaiApi = {
  async chat(variant: OpenAiVariant, body: OpenAIChatCompletionRequest) {
    const res = await apiClient.post<OpenAIChatCompletionResponse>(PATHS[variant], body);
    return res.data;
  },
};
